import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';

export const isStrongPassword: ValidatorFn = Validators.pattern(
  '^(?=.*[A-Z])' + // at least one upper case character
    '(?=.*[a-z])' + // at least one lower case character
    '(?=.*[0-9])' + // at least one number character
    '(?=.*[\\^$*.\\[\\]{}\\(\\)\\?"!@#%&\\/\\,><\':;|_~`=+\\- ])' + // at least one special character
    '[A-Za-z0-9^$*.\\[\\]\\{\\}\\(\\)\\?"!@#%&\\/\\,><\':;|_~`=+\\- ]{8,256}$' // at least 8 length and maximum 256
);

export const strongPasswordValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const regExp =
    '^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\\^$*.\\[\\]{}\\(\\)\\?"!@#%&\\/\\,><\':;|_~`=+\\- ])[A-Za-z0-9^$*.\\[\\]\\{\\}\\(\\)\\?"!@#%&\\/\\,><\':;|_~`=+\\- ]{8,256}$';
  return String(control.value).match(new RegExp(regExp)) || !control.value
    ? null
    : { weakPassword: true };
};
